import { Icon } from 'components/Icon';
import { Image } from 'components/Image';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { asset } from 'libs/asset';
import './LoginFooter.scss';
/**
 * @component LoginFooter
 * @since 1.0.0
 */
export function LoginFooter(props) {
    const { language, path } = Object.assign({}, props);
    return (React.createElement("div", { className: "login-by-email-screen-footer" },
        React.createElement("div", { className: "login-by-email-screen-footer--logo" },
            React.createElement("a", { href: "https://centralio.com", target: "_blank", rel: "noreferrer noopener" },
                React.createElement(Image, { source: asset('images/logo-light.svg') }))),
        React.createElement("div", { className: "login-by-email-screen-footer--text" },
            React.createElement(Icon, { value: "copyright" }),
            React.createElement(Text, { value: t('Centralio Technologies Inc. All rights reserved') +
                    ' ' +
                    new Date().getFullYear() +
                    '.' })),
        React.createElement("div", { className: "login-by-email-screen-footer--text" },
            React.createElement("a", { href: language === 'en'
                    ? 'https://drive.google.com/file/d/1t-bC6tvzyhWCH8eV914C9w_f73u2F3YK/view?usp=sharing'
                    : 'https://drive.google.com/file/d/1w4ukBFRN_3x3BGW2dG_WatFrMFViHxbf/view?usp=sharing', target: "_blank", rel: "noreferrer noopener" },
                React.createElement(Icon, { value: "arrow-up-right-from-square" }),
                t('Terms of Use'))),
        React.createElement("div", { className: "login-by-email-screen-footer--lang-switcher" },
            React.createElement("a", { href: (path ? path : '') + '/' + (language === 'en' ? 'fr' : 'en') },
                React.createElement(Icon, { value: "globe" }),
                React.createElement(Text, { value: language === 'fr' ? 'English' : 'Français' })))));
}
